import { useContext } from 'react'
import { UIContext } from '../contexts/ui';

// Return an audit metadata object with pre-filled fields
const useAuditMeta = () => {
  const [uiContext, ] = useContext(UIContext);
  return { userId: uiContext.userName, source: 'app'};
};

export default useAuditMeta;